import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'services/alert.service';
import { UserService } from 'services/user.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-customeramendment',
  templateUrl: './customeramendment.component.html',
  styleUrls: ['./customeramendment.component.scss']
})
export class CustomeramendmentComponent implements OnInit {

  form: FormGroup;
  searchValue: string;
  isShowUserDetails: boolean = false;
  userDetails: any;
  emailsearchedValue: string;

  constructor(private formBuilder: FormBuilder,
    private userservice: UserService,
    private alertService: AlertService,
    private el: ElementRef,
    public dialog: MatDialog) { }



  ngOnInit() {
    this.searchValue = '';
    this.initializeValidators();
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
      identificationNumber: ['', [Validators.required]],
      mobileNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      email: ['', [Validators.required, Validators.email]],
      currentEmail: ['', null],
      whatsAppNumber:['']

    });
  }


  searchCustomer(searchValue: string) {
    this.searchValue = searchValue.trim();
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.get(this.searchValue);
    }
  }

  get(search) {
        this.emailsearchedValue = search;
    this.userservice.getAmendCustomer(search).subscribe(result => {

      if (result) {        
        this.isShowUserDetails = true;
        this.userDetails = result;
        this.form.patchValue(this.userDetails);
      }
      else {
        // this.searchValue = '';
        this.alertService.warning('No data found');
        this.form.reset();
        this.userDetails = null;
        this.isShowUserDetails = false;
      }
    });
  }

  onFilter() {
    this.get(this.searchValue);
  }

  onRefresh() {
    this.searchValue = '';
    this.form.reset();
    this.userDetails = null;
    this.isShowUserDetails = false;
  }



  onSubmit() {


    if(this.form.value.mobileNumber){
      if(this.form.value.mobileNumber.length < 9){
        this.alertService.warning('Please enter valid cellphone number');
        return;
      }
      else if(this.form.value.mobileNumber.length == 10){
        var mobile = this.form.value.mobileNumber[0];
        if(mobile != 0){
          this.alertService.warning('Please enter valid cellphone number');
          return;
        }
      }
    }

    if(this.form.value.whatsAppNumber){
      if(this.form.value.whatsAppNumber.length < 9){
        this.alertService.warning('Please enter valid WhatsApp number');
        return;
      }
      else if(this.form.value.whatsAppNumber.length == 10){
        var whatsAppNo = this.form.value.whatsAppNumber[0];
        if(whatsAppNo != 0){
          this.alertService.warning('Please enter valid WhatsApp number');
          return;
        }
      }
    }



    this.form.controls['currentEmail'].setValue(this.emailsearchedValue);

    if (this.form.valid) {
      this.userservice.submitAmendCustomer(this.form.value).subscribe(result => {

        if (result.value) {
          this.alertService.success("User Information Updated Successfully.");
          
          this.emailsearchedValue = this.form.value.email;

        }
        else {
          this.alertService.error(result.htmlFormattedFailures);
        }
      });

    }
    else {
      for (const key of Object.keys(this.form.controls)) {
        if (this.form.controls[key].invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          console.log('invalid keys', key);
          invalidControl.focus();
          break;
        }
      }
      this.alertService.error("Please fill all the required fields");
    }
  }

  resetPassword() {

    var data = {
      "email": this.emailsearchedValue
    }

    this.userservice.resetPassword(data).subscribe(result => {

      if (result == true) {
        this.alertService.success("Password Reset Successfully");
      }
      else {
        this.alertService.error("Oops something went wrong");
      }

    });

  }
}
